/** Console EmptyState/ErrorState: the UI kit states with a required next action (§1.2 "no dead ends"). */
import { EmptyState as KitEmptyState, ErrorState as KitErrorState, type StateProps } from '@windrop/ui';
import { Inbox, TriangleAlert } from 'lucide-react';

export type EmptyStateProps = StateProps;

export function EmptyState(props: EmptyStateProps) {
  return <KitEmptyState icon={<Inbox size={22} />} {...props} />;
}

export function ErrorState(props: EmptyStateProps) {
  return <KitErrorState icon={<TriangleAlert size={22} />} {...props} />;
}

/** Honest "no data yet" for tiles and tables fed by endpoints that have nothing to report. */
export function NoDataYet({ what = 'data', hint }: { what?: string; hint?: string }) {
  return (
    <p className="wdc-nodata" data-testid="no-data-yet">
      No {what} yet.{hint ? ` ${hint}` : ''}
    </p>
  );
}
